import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component, Input } from '@angular/core';

import { MenuItemSizeDto } from '../../../../api/v1/models/menu-item-size-dto';
import { NutritionInfo } from '../../../../api/v1/models/nutrition-info';

@Component({
    selector: 'app-default-portion-list',
    templateUrl: './default-portion-list.component.html',
    styleUrls: ['./default-portion-list.component.scss'],
    standalone: true,
    imports: [NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault]
})
export class DefaultPortionListComponent {
  constructor() {}

  @Input() size: MenuItemSizeDto;
  @Input() nutrition: NutritionInfo;
}
